/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getObserveInformReportById } from "./fetchData";
import { ProgressSpinner } from "primereact/progressspinner";
import { Image } from "primereact/image";

const ViewObserveInformReport: React.FC = () => {
  const query = new URLSearchParams(window.location.search);
  const formIDParam = Number(query.get("formID"));

  const toast = useRef<Toast>(null);
  const [formData, setFormData] = useState<any>(null);
  const [formDataLoading, setFormDataLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  console.log("formData", formData);

  const icon = (
    <i
      className="pi pi-eye tw-text-white tw-h-full tw-w-full tw-justify-center tw-items-center tw-flex"
      style={{
        backgroundColor: "black",
        opacity: 0.5,
        transition: "opacity 0.3s ease",
      }}
    ></i>
  );

  useEffect(() => {
    if (!formIDParam) {
      navigate("/layout/health-and-safety/observe-inform-report");
      return;
    }
    getObserveInformReportById(
      setFormData,
      setFormDataLoading,
      formIDParam,
      navigate,
      toast,
    );
  }, []);

  // Format date from epoch timestamp
  const formatDate = (timestamp: number) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // const getObservationBadgeClass = (observation: string) => {
  //   return observation === "Good"
  //     ? "tw-bg-green-100 tw-text-green-800"
  //     : "tw-bg-red-100 tw-text-red-800";
  // };

  // const getProjectNameBadgeClass = (projectName: string) => {
  //   switch (projectName) {
  //     case "Safety":
  //       return "tw-bg-blue-100 tw-text-blue-800";
  //     case "Quality":
  //       return "tw-bg-purple-100 tw-text-purple-800";
  //     case "Environmental":
  //       return "tw-bg-green-100 tw-text-green-800";
  //     default:
  //       return "tw-bg-gray-100 tw-text-gray-800";
  //   }
  // };

  return (
    <>
      <Toast ref={toast} />
      {formDataLoading ? (
        <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-[50px] lg:tw-left-[120px] tw-z-50">
          <ProgressSpinner />
        </div>
      ) : (
        <div className="form-border">
          <div className="form-header-border">
            <h2 className="form-header-h2">View Observe. Inform. Report.</h2>
          </div>

          <div className="tw-p-4">
            {/* Basic Information */}
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-6">
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Name</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formData?.formJson?.name || "-"}
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Date</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formatDate(formData?.formJson?.date) || "N/A"}
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Amelio Department</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formData?.department?.name || "N/A"}
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Observation Type</p>
                <span
                  // className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium ${getProjectNameBadgeClass(
                  //   formData?.formJson?.project?.name,
                  // )}`}
                  className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-text-[#374151] tw-break-words tw-max-w-full`}
                >
                  {formData?.formJson?.project?.name || "N/A"}
                </span>
              </div>
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Site Name & Location</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formData?.formJson?.siteLocation || "N/A"}
                </p>
              </div>
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Observation</p>
                <span
                  // className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium ${getObservationBadgeClass(
                  //   formData?.formJson?.observation?.name,
                  // )}`}
                  className={`tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-text-[#374151] tw-break-words tw-max-w-full`}
                >
                  {formData?.formJson?.observation?.name || "N/A"}
                </span>
              </div>

              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Submitted By</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formData?.formJson?.submittedBy?.displayName
                    ? formData.formJson.submittedBy.displayName === "N/A"
                      ? formData?.formJson?.name
                      : formData.formJson.submittedBy.displayName
                    : formData?.formJson?.name || "-"}
                </p>
              </div>
            </div>

            {/* Description */}
            <div className="tw-mt-6">
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Description</p>
                <p className="leak-value tw-whitespace-pre-wrap tw-break-words tw-max-w-full">
                  {formData?.formJson?.description || "N/A"}
                </p>
              </div>
            </div>

            {/* Photos */}
            {formData?.fileJson?.photos &&
              formData.fileJson.photos.length > 0 && (
                <div className="tw-mt-6">
                  <p className="leak-detail-label tw-mb-2">Photos</p>
                  <div className="tw-flex tw-flex-wrap tw-gap-4">
                    {formData.fileJson.photos.map(
                      (photo: any, index: number) => (
                        <div
                          key={index}
                          className="tw-w-32 tw-h-32 tw-rounded-lg tw-overflow-hidden tw-border tw-border-gray-300"
                        >
                          <Image
                            src={photo.file}
                            alt={photo.originalname || `Photo ${index + 1}`}
                            preview
                            className="tw-w-full tw-h-full"
                            imageClassName="tw-w-full tw-h-full tw-object-cover"
                            indicatorIcon={icon}
                            pt={{
                              rotateRightButton: { className: "tw-text-white" },
                              downloadButton: { className: "tw-text-white" },
                              rotateLeftButton: { className: "tw-text-white" },
                              zoomInButton: { className: "tw-text-white" },
                              zoomOutButton: { className: "tw-text-white" },
                              closeButton: { className: "tw-text-white" },
                            }}
                          />
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}
            {formData?.timeStampLocationJson?.locations?.map(
              (location: any) => {
                if (
                  location?.userID === formData?.formJson?.teamMember1?.userID
                ) {
                  const timestamp =
                    formData?.timeStampLocationJson?.timeStamps?.find(
                      (time: any) => time?.userID === location?.userID,
                    );
                  return (
                    <div key={location?.userID} className="tw-mt-2">
                      <p className="tw-text-sm tw-text-gray-600">
                        <span className="tw-font-semibold">Location:</span>{" "}
                        {location?.address}
                      </p>
                      <p className="tw-text-sm tw-text-gray-600">
                        <span className="tw-font-semibold">Timestamp:</span>{" "}
                        {timestamp?.timestamp}
                      </p>
                    </div>
                  );
                }
                return null;
              },
            )}
            {/* Control Measures */}
            {formData?.formJson?.controlMeasures && (
              <div className="tw-mt-6">
                <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                  <p className="leak-detail-label">Control Measures</p>
                  <p className="leak-value tw-whitespace-pre-wrap tw-break-words tw-max-w-full">
                    {formData?.formJson?.controlMeasures}
                  </p>
                </div>
              </div>
            )}

            {/* Created Date */}
            <div className="tw-mt-6 tw-pt-4 tw-border-t tw-border-gray-200">
              <div className="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-min-w-0">
                <p className="leak-detail-label">Created On</p>
                <p className="leak-value tw-break-words tw-max-w-full">
                  {formData?.createdDate
                    ? new Date(formData.createdDate).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                    : "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="tw-flex tw-justify-end tw-items-center tw-p-4 tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
            <Button
              className="form-cancel-button"
              label="Back"
              onClick={() =>
                navigate("/layout/health-and-safety/observe-inform-report")
              }
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ViewObserveInformReport;
